import { HttpError } from "@refinedev/core";
import { useTable } from "@refinedev/react-table";

import { DataTable } from "@/components/refine-ui/data-table/data-table";
import { DataTableActionBar } from "@/components/refine-ui/data-table/data-table-action-bar";
import { ListView } from "@/components/refine-ui/views/list-view";
import { useShowGenreColumns } from "@/pages/show-genres/hooks/use-columns";
import { IShowGenreData } from "@/types/show-genre";

export const ShowGenresList = () => {
  const columns = useShowGenreColumns();

  const table = useTable<IShowGenreData, HttpError>({
    columns,
    enableColumnResizing: true,
    columnResizeMode: "onChange",
    initialState: {
      columnVisibility: { id: false },
      columnPinning: { right: ["actions"] },
    },
    refineCoreProps: {
      resource: "show-genres",
      meta: { defaultQueryBy: "name" },
      sorters: { initial: [{ field: "name", order: "asc" }] },
      pagination: { pageSize: 25 },
    },
  });

  return (
    <ListView>
      <DataTableActionBar resource="show-genres" table={table} />
      <DataTable table={table} />
    </ListView>
  );
};
